import { Material } from "./../../pages/CreationSpace/CreativeSpace/CreativeContainer/components/Material/Material";
import { getGridPixel, getSelectFrame } from "@/utils/canvasUtil";
import { Group, TrackLineItem } from "./class/Track";
import { makeAutoObservable, action } from "mobx";
import { VideoMaterial } from "./class/VideoTrack";
import { AudioMaterial } from "./class/AudioTrack";
import { TextMaterial } from "./class/TextTrack";
import { formatTime, isVideo } from "@/utils/tool";
import { ImageMaterial } from "./class/ImageTrack";
import playerStore from "@/stores/clip/player";
import { cloneDeep } from "lodash-es";
import { v4 as uuid } from "uuid";
import { trackDirectionUp } from "./data/trackConfig";
import { CSSProperties } from "react";

export type Material =
  | VideoMaterial
  | AudioMaterial
  | TextMaterial
  | ImageMaterial;

export interface InsertInfo {
  insertIndex: number;
  itemIndex: number;
  left: number;
  right: number;
  isNewLine: boolean;
  start?: number;
  end?: number;
}

class TrackState {
  isClip = false;
  canMove = false;
  scrollData: {
    scrollTop: number;
    direction: "up" | "down" | "";
    scrollX: boolean;
    scrollY: boolean;
    style: any;
  } = {
    scrollTop: 0,
    direction: "",
    scrollX: false,
    scrollY: false,
    style: {},
  };
  insertInfo: InsertInfo = {
    insertIndex: -1,
    itemIndex: -1,
    left: 0,
    right: 0,
    isNewLine: false,
    start: 0,
    end: 0,
  };
  dragData = {
    dataInfo: {} as Group,
    dragType: "",
    dragPoint: {
      x: 0,
      y: 0,
    },
    // 吸附辅助线
    fixLines: [] as { position: number; frame: number }[][],
    moveX: 0,
    moveY: 0,
  };

  // 拖动素材的数据
  dragMaterialData = {
    dragPoint: {
      x: 0,
      y: 0,
    },
  };

  curCoord = { left: 0, right: 0, start: 0, end: 0 };
  otherCoord: {
    left: number;
    right: number;
    start: number;
    end: number;
  }[] = [];
  dragElement = null;
  fixPosition = { left: 0, right: 0, start: 0, end: 0 };

  // 行内移动
  moveTrackData = {
    lineIndex: -1,
    itemIndex: -1,
  };

  trackScale = parseInt(localStorage.trackS || "40");
  trackList: TrackLineItem[] = [];
  // 选中元素坐标
  selectGroupItem = {
    line: -1,
    index: -1,
    materialIndex: -1,
  };
  constructor() {
    makeAutoObservable(this);
  }

  get thumbTrack() {
    return this.trackList.find((item) => item.type === "thumb");
  }

  get selectResorce() {
    if (this.selectGroupItem.line === -1) {
      return null;
    }
    return (
      this.trackList[this.selectGroupItem.line]?.groups[
        this.selectGroupItem.index
      ] || null
    );
  }

  // get coords() {
  //   const coords = [];
  //   for (let i = 0; i < this.trackList.length; i++) {
  //     for (let j = 0; j < this.trackList[i].groups.length; j++) {
  //       if (
  //         i !== this.selectGroupItem.line ||
  //         j !== this.selectGroupItem.index
  //       ) {
  //         const item = this.trackList[i].groups[j];
  //         coords.push({
  //           start: item.start,
  //           end: item.end,
  //           left: getGridPixel(this.trackScale, item.start),
  //           right: getGridPixel(this.trackScale, item.end),
  //         });
  //       }
  //     }
  //   }

  //   return coords;
  // }

  get showTrackList() {
    return this.trackList.map((line, lineIndex) => {
      // line.main && (mainIndex = lineIndex);
      const newList = line.groups.map((item) => {
        const { duration: time } = (item.materials[item.activeSourceIndex] ??
          {}) as VideoMaterial;
        return {
          ...item,
          source: item.materials[item.activeSourceIndex],
          showWidth: `${getGridPixel(this.trackScale, item.end - item.start)}px`,
          showLeft: `${getGridPixel(this.trackScale, item.start)}px`,
          time: item.materials.length
            ? formatTime(
                Math.max.apply(
                  null,
                  item.materials.map((source) => source.duration)
                ) || 0
              ).str
            : 300,
        };
      });
      return {
        ...line,
        groups: newList,
      };
    });
  }

  resetState() {
    this.isClip = false;
    this.canMove = false;
    playerStore.playStartFrame = 0;
    this.scrollData = {
      scrollTop: 0,
      direction: "",
      scrollX: false,
      scrollY: false,
      style: {},
    };
    this.insertInfo = {
      insertIndex: -1,
      itemIndex: -1,
      left: 0,
      right: 0,
      isNewLine: false,
      start: 0,
      end: 0,
    };
    this.dragData = {
      dataInfo: {} as Group,
      dragType: "",
      dragPoint: {
        x: 0,
        y: 0,
      },
      // 吸附辅助线
      fixLines: [] as { position: number; frame: number }[][],
      moveX: 0,
      moveY: 0,
    };
    this.curCoord = { left: 0, right: 0, start: 0, end: 0 };
    this.otherCoord = [];
    this.dragElement = null;
    this.fixPosition = { left: 0, right: 0, start: 0, end: 0 };
    this.moveTrackData = {
      lineIndex: -1,
      itemIndex: -1,
    };
    this.trackScale = parseInt(localStorage.trackS || "40");
    this.trackList = [];
    this.selectGroupItem = {
      line: -1,
      index: -1,
      materialIndex: -1,
    };
  }

  getFixLine(x: number, distance = 5) {
    // otherCoord、游标位置
    // 先获取与拖拽元素left、right，距离小于distance的元素
    const result = [];
    this.otherCoord.forEach((coord) => {
      if (Math.abs(coord.left - x) <= distance) {
        result.push({ position: coord.left, frame: coord.start });
      }
      if (Math.abs(coord.right - x) <= distance) {
        result.push({ position: coord.right, frame: coord.end });
      }
    });

    // 获取与游标位置距离小于distance的元素
    // 1.获取游标的x坐标
    const trackPlayPointX = getGridPixel(
      this.trackScale,
      playerStore.playStartFrame
    );
    // console.log("trackPlayPointX", trackPlayPointX);

    // 2.获取与游标位置距离小于distance的元素
    if (Math.abs(trackPlayPointX - x) <= distance) {
      result.push({
        position: trackPlayPointX,
        frame: playerStore.playStartFrame,
      });
    }

    return result;
  }

  getComputedPosition(element: HTMLElement) {
    console.log("element", element);

    const style = window.getComputedStyle(element);
    console.log("getComputedPosition", style.left, style.width);

    return {
      left: parseInt(style.left),
      right: parseInt(style.left) + parseInt(style.width),
    };
  }

  getInsertLineInfoMaterial() {
    // 获取拖拽最后的中心点
  }

  getIndexOfDirection(originIndex: number, custype?: string) {
    const mainIndex = this.trackList.findIndex((line) => line.main);
    const type = custype || this.dragData.dataInfo.type;
    console.log("getIndexOfDirection", mainIndex, originIndex);

    if (trackDirectionUp.includes(type)) {
      return originIndex <= mainIndex
        ? Math.max(originIndex, this.thumbTrack ? 1 : 0)
        : Math.max(mainIndex - 1, 0);
    } else {
      return originIndex > mainIndex ? originIndex : this.trackList.length;
    }
  }

  getInsertLineInfo(): {
    isNewLine: boolean;
    insertIndex: number;
    elem?: HTMLElement;
  } {
    console.log(
      "------------",
      this.dragElement.offsetTop,
      this.dragElement.offsetParent.offsetTop
    );

    // 获取拖拽最后的中心点
    const center =
      this.dragElement.offsetTop +
      this.dragElement.offsetHeight / 2 +
      (this.dragElement.offsetParent as HTMLElement).offsetTop;

    console.log("center", center);

    const elems = Array.from(
      document.querySelectorAll(".trackLine")
    ) as HTMLElement[];

    // 处理边界情况
    // 1. center在第一个元素之前
    if (elems[0].offsetTop > center) {
      return { isNewLine: true, insertIndex: this.getIndexOfDirection(0) };
    }

    for (let i = 0; i < elems.length; i++) {
      const elem = elems[i];
      // center在一个元素中
      if (
        elem.offsetTop <= center &&
        elem.offsetTop + elem.offsetHeight >= center
      ) {
        return {
          isNewLine: false,
          insertIndex: this.getIndexOfDirection(i),
          elem,
        };
      }
      if (i + 1 !== elems.length) {
        const elemNext = elems[i + 1];
        // center在两个元素之间
        if (
          elem.offsetTop + elem.offsetHeight <= center &&
          elemNext.offsetTop >= center
        ) {
          return {
            isNewLine: true,
            insertIndex: this.getIndexOfDirection(i + 1),
          };
        }
      }
    }
    // 2. center在最后一个元素之后
    return {
      isNewLine: true,
      insertIndex: this.getIndexOfDirection(elems.length),
    };
  }

  getInsertInfo(): InsertInfo {
    // eslint-disable-next-line prefer-const
    let { isNewLine, insertIndex, elem } = this.getInsertLineInfo();

    const style = this.getComputedPosition(this.dragElement);

    const left = this.fixPosition.left || style.left;
    const right = this.fixPosition.right || style.right;
    console.log("fixPosition", this.fixPosition);

    const start =
      this.fixPosition.start || getSelectFrame(left, this.trackScale, 30);
    const end =
      this.fixPosition.end || getSelectFrame(right, this.trackScale, 30);

    console.log("elm style", elem, style);

    if (!elem) {
      const insertInfo = {
        insertIndex,
        itemIndex: 0,
        left,
        right,
        isNewLine,
        start,
        end,
      };
      this.insertInfo = insertInfo;
      return insertInfo;
    }

    const dragItem = this.dragData.dataInfo;
    console.log("dragItem", dragItem);
    const line = this.trackList[insertIndex];
    console.log("line", line);
    // if (!line) return;
    const { overlap, index: itemIndex } = this.isOverlap(dragItem, line, {
      start,
      end,
    });
    console.log("itemIndex--------", itemIndex);

    // 如果重叠，根据位置判断是插入当前行之前还是之后
    if (overlap) {
      isNewLine = true;
      // 获取elem的中心点
      const center = elem.offsetLeft + elem.offsetWidth / 2;
      if (
        center <
        this.dragElement.offsetTop +
          (this.dragElement.offsetParent as HTMLElement).offsetTop +
          this.dragElement.offsetHeight / 2
      ) {
        insertIndex -= this.getIndexOfDirection(1);
      }
    }

    const insertInfo = {
      insertIndex,
      itemIndex,
      left,
      right,
      isNewLine,
      start,
      end,
    };
    console.log("set insertinfo", insertInfo);

    this.insertInfo = insertInfo;
    return insertInfo;
  }

  setScrollData(v) {
    this.scrollData = v;
  }

  judgeCanMove(targetTrackList, insertInfo) {
    const prev = targetTrackList[insertInfo.insertIndex - 1] ?? null;
    const next = targetTrackList[insertInfo.insertIndex + 1] ?? null;
    console.log(
      "judgeCanMove",
      targetTrackList,
      prev?.type,
      next?.type,
      this.dragData.dataInfo
    );

    if (next?.type === "thumb") {
      this.canMove = false;
      return false;
    }

    return true;

    // // 插入到了其他两个元素的中间，不允许插入
    // if (
    //   prev?.type === next?.type &&
    //   prev?.type !== this.dragData.dataInfo.type
    // ) {
    //   this.canMove = false;
    //   return false;
    // }

    // if (
    //   prev?.type === this.dragData.dataInfo.type ||
    //   next?.type === this.dragData.dataInfo.type
    // ) {
    //   this.canMove = true;
    //   return true;
    // }

    // console.log(prev, next);
    // const sameTypeNum =
    //   targetTrackList.filter(
    //     (item) => item.type === this.dragData.dataInfo.type
    //   ).length ?? 0;
    // // 如果只有一个，说明是第一次插入
    // if ((sameTypeNum === 2 && insertInfo.isNewLine) || sameTypeNum === 1) {
    //   this.canMove = true;
    //   return true;
    // }

    // const dragItem = this.dragData.dataInfo;
    // if (dragItem.type === prev?.type || dragItem.type === next?.type) {
    //   this.canMove = true;
    //   return true;
    // }

    // this.canMove = false;
    // return false;
  }

  insert(insertInfo: InsertInfo, change = true) {
    console.log("进入insert", insertInfo);
    if (!insertInfo) return;

    const dragInfo = this.dragData.dataInfo;
    console.log("fixPosition", this.fixPosition);

    const startFrame = Math.max(
      this.fixPosition.right !== 0
        ? getSelectFrame(insertInfo.right, this.trackScale, 30) -
            (dragInfo.end - dragInfo.start)
        : getSelectFrame(insertInfo.left, this.trackScale, 30),
      0
    );
    console.log("startFrame", startFrame, dragInfo.end - dragInfo.start);

    // 移动元素到新为止
    const thumbFrameCount =
      dragInfo.type !== "thumb"
        ? this.thumbTrack?.groups?.[0]?.frameCount || 0
        : 0;

    // dragInfo.start = startFrame;
    // dragInfo.end = startFrame + (dragInfo.end - dragInfo.start);
    dragInfo.start = Math.max(startFrame, thumbFrameCount);
    dragInfo.end = dragInfo.start + dragInfo.frameCount;

    const newTrackItem = dragInfo;
    // 先根据id将原本的trackItem设置为null
    let deleteLineIndex = 0;
    let deleteItemIndex = 0;
    this.trackList.forEach((lineItem, lineIndex) => {
      lineItem.groups.forEach((item, itemIndex) => {
        if (item.id === dragInfo.id) {
          deleteLineIndex = lineIndex;
          deleteItemIndex = itemIndex;
        }
      });
    });
    const targetTrackList = cloneDeep(this.trackList);
    targetTrackList[deleteLineIndex].groups.splice(deleteItemIndex, 1);
    if (insertInfo.isNewLine) {
      // 插入新行
      targetTrackList.splice(insertInfo.insertIndex, 0, {
        type: newTrackItem.type,
        groups: [newTrackItem],
      });
    } else {
      // 插入当前行
      targetTrackList[insertInfo.insertIndex].groups.splice(
        insertInfo.itemIndex,
        0,
        newTrackItem
      );
    }
    // 删除store.trackList中，list为空的元素
    const deleteIndex = targetTrackList.findIndex(
      (lineItem) => lineItem.groups.length === 0
    );
    // const canMove = this.judgeCanMove(targetTrackList, insertInfo);
    // console.log(
    //   "canMove------------",
    //   canMove,
    //   JSON.stringify(this.insertInfo)
    // );

    // if (!canMove) return;
    if (deleteIndex !== -1) {
      targetTrackList.splice(deleteIndex, 1);
    }
    if (change) {
      this.trackList = targetTrackList;
    }
  }

  setIsClip(v: boolean) {
    this.isClip = v;
  }

  getFrameCount() {
    return this.trackList.reduce((res, { groups }) => {
      return Math.max(
        groups.reduce((max, track) => Math.max(max, track.end), 0),
        res
      );
    }, 0);
  }

  setDragData(data: any) {
    // this.dragData = { ...this.dragData, ...data };
    Object.assign(this.dragData, data); // 直接修改属性
  }

  setDragMaterialData(data: any) {
    // this.dragData = { ...this.dragData, ...data };
    Object.assign(this.dragMaterialData, data); // 直接修改属性
  }

  setInsertInfo(data: any) {
    // this.insertInfo = {...this.insertInfo,...data };
    Object.assign(this.insertInfo, data); // 直接修改属性
  }

  setMoveTrackData(data: any) {
    Object.assign(this.moveTrackData, data);
  }

  setTrackScale(v: number) {
    this.trackScale = v;
  }

  setSelectTrackItem(item) {
    this.selectGroupItem = { ...this.selectGroupItem, ...item };
  }

  updateGroup(lineIndex, index, data) {
    // console.log("updateGroup", this.trackList[lineIndex].groups[index], data);

    // this.trackList[lineIndex].groups[index] = {
    //   ...this.trackList[lineIndex].groups[index],
    //   ...data,
    // };

    this.trackList[lineIndex].groups[index] = Object.create(
      Object.getPrototypeOf(this.trackList[lineIndex].groups[index]),
      {
        ...Object.getOwnPropertyDescriptors(
          this.trackList[lineIndex].groups[index]
        ),
        ...Object.getOwnPropertyDescriptors(data),
      }
    );

    // console.log(55555, this.trackList[lineIndex].groups[index]);
    // Object.assign(this.trackList[lineIndex].groups[index], data); // 直接修改属性
  }

  // 删除元素
  removeGroup(lineIndex: number, itemIndex: number) {
    if (
      this.trackList[lineIndex].groups.length <= 1 &&
      this.trackList[lineIndex].main
    )
      return;

    this.trackList[lineIndex].groups.splice(itemIndex, 1);
    if (
      this.trackList[lineIndex].groups.length === 0 &&
      !this.trackList[lineIndex].main
    ) {
      this.trackList.splice(lineIndex, 1);
    }
    if (this.trackList.length === 1 && this.trackList[0].groups.length === 0) {
      this.trackList.splice(0, 1);
    }

    if (this.trackList[lineIndex]?.type === "video") this.adjustVideoTrack();
  }

  selectGroupById(id: string) {
    this.trackList.forEach((item, index) => {
      item.groups.forEach((group, trackIndex) => {
        if (group.id === id) {
          this.selectGroupItem.line = index;
          this.selectGroupItem.index = trackIndex;
        }
      });
    });
  }

  addGroup(
    group: Group,
    lineIndex?: number, // 插入的行索引
    position?: { x: number; y: number } // 落点位置
  ) {
    console.log("add group", group, lineIndex, position);
    const lines = this.trackList.filter((line) => line.type === group.type);
    const rect = document.querySelector(".track-list").getBoundingClientRect();
    console.log(11111, this.dragData.dragPoint.y - rect.top, rect.height);
    const isTop =
      this.dragMaterialData.dragPoint.y - rect.top < rect.height / 2;

    // for (let index = 0; index < lines.length; index++) {
    //   const line = lines[index];
    //   const { hasOverlap, insertIndex } = this.checkTrackListOverlap(
    //     line.groups,
    //     group
    //   );
    //   console.log("hasOverlap===========", hasOverlap);

    //   if (!hasOverlap) {
    //     line.groups.splice(insertIndex, 0, group);
    //     this.selectGroupItem.line = index;
    //     this.selectGroupItem.index = insertIndex;
    //     return;
    //   }
    // }

    if (group.type === "video") {
      // video and images
      const index = this.trackList.findIndex((line) => line.type === "video");
      if (index === -1) {
        this.trackList.push({
          id: uuid(),
          main: true,
          type: "video",
          groups: [group],
        });
      } else {
        // group.frameCount = Math.max.apply(
        //   null,
        //   group.materials.map((source) => (source.duration / 1000) * 30)
        // );
        // group.offsetR = 0;
        this.trackList[index].groups = [...this.trackList[index].groups, group];
      }

      this.selectGroupItem.line = this.trackList.length - 1;
      this.selectGroupItem.index = 0;
    } else if (group.type === "thumb") {
      group.start = 0;
      group.end = group.frameCount;
      const exsit = !!this.thumbTrack;
      if (!exsit) {
        this.trackList.unshift({
          id: uuid(),
          type: "thumb",
          groups: [group],
        });
      } else {
        group.frameCount = this.thumbTrack.groups[0].frameCount;
        group.end = this.thumbTrack.groups[0].frameCount;
        this.updateGroup(0, 0, group);
      }
    } else {
      console.log("position", position);

      const perPiexl = getGridPixel(this.trackScale, 1);
      const start = Math.max(
        (position.x - 138) / perPiexl,
        this.thumbTrack?.groups?.[0]?.frameCount || 0
      );
      const isDirectionUp = trackDirectionUp.includes(group.type);

      console.log("isTop-------", isTop);

      if (lineIndex === null) {
        const lastIndex = (this.trackList as any).findLastIndex(
          (line) => line.type === group.type
        );
        group.start = start;
        group.end = start + group.frameCount || 150;
        // 主轨道下方，直接push
        if (!isDirectionUp) {
          console.log("direction------------: group bottom");

          let index;
          if (isTop) {
            // 落点位于轨道列表上半部分，插入到开头
            index = this.trackList.findIndex((line) => line.main) + 1;
          } else {
            // 落点位于轨道列表下半部分，插入到视频轨道上方
            index = this.trackList.length + 1;
          }
          console.log("index-------", index);

          this.trackList.splice(index, 0, {
            id: uuid(),
            type: group.type,
            groups: [group],
          });
          this.selectGroupItem.line = index;
          this.selectGroupItem.index = 0;
        } else {
          // 主轨道上方，
          console.log("direction------------: group top");
          let index;
          if (isTop) {
            // 落点位于轨道列表上半部分，插入到开头
            index = this.thumbTrack ? 1 : 0;
          } else {
            // 落点位于轨道列表下半部分，插入到视频轨道上方
            const mainIndex = this.trackList.findIndex((line) => line.main);
            index = this.getIndexOfDirection(mainIndex, group.type);
          }

          console.log("index-------", index);

          this.trackList.splice(index, 0, {
            id: uuid(),
            type: group.type,
            groups: [group],
          });

          this.selectGroupItem.line = index;
          this.selectGroupItem.index = 0;
        }
      } else {
        const { overlap, index: itemIndex } = this.isOverlap(
          { type: group.type },
          this.trackList[lineIndex],
          {
            start,
            end: start + group.frameCount || 150,
          }
        );
        console.log("start-----------", start);

        if (overlap) {
          // 新增一行
          const index = this.getIndexOfDirection(lineIndex, group.type);
          group.start = start;
          group.end = start + group.frameCount || 150;
          this.trackList.splice(index, 0, {
            id: uuid(),
            main: false,
            type: group.type,
            groups: [group],
          });
          // this.trackList[lineIndex+1].groups.push(group);
          // this.selectGroupItem.line = lineIndex;
          // this.selectGroupItem.index = itemIndex;
          // this.addMaterial(lineIndex, itemIndex, group.materials[0]);
        } else {
          group.start = start;
          group.end = start + group.frameCount || 150;
          this.trackList[lineIndex].groups.push(group);
          this.selectGroupItem.line = lineIndex;
          this.selectGroupItem.index = itemIndex;
        }
        console.log("checkOverlap", overlap, itemIndex);
      }
    }

    console.log("group--------", group);

    if (group.type === "thumb") {
      this.adjustThumbTrack();
      this.adjustVideoTrack();
    }
  }

  addMaterial(lineIndex, groupIndex, material) {
    if (!material) {
      return;
    }
    // console.log("lineIndex groupIndex", lineIndex, groupIndex, material);

    if (lineIndex != null && groupIndex != null) {
      const trackItem = this.trackList[lineIndex].groups[groupIndex];
      trackItem.materials.push(material);
      // trackItem.frameCount = Math.max.apply(
      //   null,
      //   trackItem.materials.map((source) => (source.duration / 1000) * 30)
      // );
      console.log("trackItem.frameCount", trackItem);

      trackItem.frameCount = trackItem.frameCount || 30 * 5;
      // trackItem.offsetR = 150 - trackItem.frameCount;
      // trackItem.end = trackItem.start + trackItem.frameCount;
      this.updateGroup(lineIndex, groupIndex, trackItem);
    } else {
      // 新增一行
      this.trackList.push({
        id: uuid(),
        main: material.type === "video",
        type: material.type,
        groups: [material],
      });
    }
  }

  checkTrackListOverlap(trackList: Group[], checkItem: Group, moveIndex = -1) {
    console.log("checkTrackListOverlap", trackList, checkItem);

    const { start: insertStart, end: insertEnd } = checkItem;
    let overLapIndex = -1;
    let insertIndex = 0;
    const hasOverlap = trackList.some((trackItem, index) => {
      if (moveIndex !== -1 && index === moveIndex) {
        // 行内移动情况下忽略掉移动元素
        return false;
      }
      const { start, end } = trackItem;
      // 当前列表中元素 开始帧处于新元素内部，或结束帧处于新元素内部，则视为重叠
      if (
        (start <= insertStart && end >= insertEnd) || // 添加节点的开始和结束位置位于老节点外 或 两端相等
        (start >= insertStart && start < insertEnd) || // 老节点开始位置在添加节点内部
        (end > insertStart && end <= insertEnd) // 老节点结束位置在添加节点内部
      ) {
        overLapIndex = index;
        return true;
      } else {
        if (end <= insertStart) {
          insertIndex = index + 1;
        }
        return false;
      }
    });
    return {
      hasOverlap,
      overLapIndex,
      insertIndex,
    };
  }

  isOverlap(dragItem, line, { start, end }: { start: number; end: number }) {
    if (dragItem.type !== line?.type) {
      return { overlap: true, index: 0 };
    }
    // 插入的位置在trackLine中
    const nodes = line.groups.filter((item) => item.id !== dragItem.id);
    console.log("nodes", nodes);
    console.log("line.groups", line.groups);
    console.log("dragItem", dragItem);
    console.log("start,end", start, end);

    if (nodes.length === 0) {
      return { overlap: false, index: 0 };
    }
    // 处理边界问题
    if (nodes[0].start >= end) {
      return { overlap: false, index: 0 };
    }
    if (nodes[nodes.length - 1].end <= start) {
      return { overlap: false, index: nodes.length };
    }
    for (let i = 0; i < nodes.length - 1; i++) {
      const node = nodes[i];
      const nextNode = nodes[i + 1];
      console.log("preNode", nextNode.start);

      // 这里1设置一个阈值，解决精度丢失的问题，如果start和end相差小于4，就认为不是重叠
      if (start + 4 >= node.end && end - 4 <= nextNode.end) {
        if (end - 4 >= nextNode.start) {
          return { overlap: true, index: i + 1 };
        }
        return { overlap: false, index: i + 1 };
      }
    }
    // 当重叠时，创建新行，所以插入位置为0
    return { overlap: true, index: 0 };
  }

  adsorption(
    { left, right }: { left: number; right: number },
    lines: { position: number; frame: number }[][]
  ) {
    this.fixPosition = { left: 0, right: 0, start: 0, end: 0 };
    if (lines[0].length === 0 && lines[1].length === 0) {
      return;
    }
    // 吸附其实就是移动拖拽元素的位置
    // 找到最近的线，计算移动的距离
    const minLeftLine = lines[0].reduce(
      (r, item) => {
        return Math.abs(item.position - left) < Math.abs(r.position - left)
          ? item
          : r;
      },
      { position: Number.MAX_SAFE_INTEGER, frame: 0 }
    );

    const minRightLine = lines[1].reduce(
      (r, item) => {
        return Math.abs(item.position - right) < Math.abs(r.position - right)
          ? item
          : r;
      },
      { position: Number.MAX_SAFE_INTEGER, frame: 0 }
    );

    console.log(
      "adsorption-----------",
      Math.abs(minLeftLine.position - left),
      Math.abs(minRightLine.position - right)
    );

    if (
      Math.abs(minLeftLine.position - left) <
      Math.abs(minRightLine.position - right)
    ) {
      // 左对齐
      this.fixPosition.left = minLeftLine.position;
      this.fixPosition.start = minLeftLine.frame;

      // trackStateStore.dragData.moveX = minLeftLine.position - curCoord.left;
      this.setDragData({
        moveX: minLeftLine.position - this.curCoord.left,
      });
    } else {
      // 右对齐
      this.fixPosition.right = minRightLine.position;
      this.fixPosition.end = minRightLine.frame;

      this.setDragData({
        moveX: minRightLine.position - this.curCoord.right,
      });
      // trackStateStore.dragData.moveX = minRightLine.position - curCoord.right;
    }
  }

  // 修正视频轨道位置，保持紧凑吸附状态
  adjustVideoTrack() {
    const trackIndex = this.trackList.findIndex(
      (line) => line.type === "video"
    );
    const videoGroups = this.trackList[trackIndex].groups;
    let diff = 0;
    this.trackList.forEach((track, trackIndex) => {
      if (track.type === "video") {
        track.groups.forEach((group, index) => {
          if (index === 0 && group.start !== 0) {
            console.log("groupo-------------", group);
            diff = group.start;
            this.updateGroup(trackIndex, index, {
              start: 0 + (this.thumbTrack?.groups[0].frameCount || 0),
              end:
                group.end - diff + (this.thumbTrack?.groups[0].frameCount || 0),
            });
          } else if (index > 0) {
            diff = group.start - videoGroups[index - 1].end;
            this.updateGroup(trackIndex, index, {
              start: videoGroups[index - 1].end,
              end: group.end - diff,
            });
          }
        });
      } else if (track.type !== "thumb") {
        track.groups.forEach((group, index) => {
          this.updateGroup(trackIndex, index, {
            start: Math.max(
              group.start,
              this.thumbTrack?.groups[0].frameCount || 0
            ),
            end:
              group.frameCount +
              Math.max(group.start, this.thumbTrack?.groups[0].frameCount || 0),
          });
        });
      }
    });
  }

  adjustThumbTrack() {
    const thumbTrack = this.trackList.find((item) => item.type === "thumb");
    const frameCount = thumbTrack.groups[0].frameCount;

    this.trackList.forEach((line) => {
      if (line.type !== "thumb") {
        line.groups.forEach((group) => {
          if (group.start < frameCount) {
            group.start = frameCount;
            group.end = frameCount + group.frameCount;
          }
        });
      }
    });
  }
}

const trackState = new TrackState();
export default trackState;
